import { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

class IssuedBloodBags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      issues: [],
      loading: true,
      error: "",
      searchTerm: "",
      filterBloodGroup: "",
    };
  }

  componentDidMount() {
    this.fetchIssues();
  }

  async fetchIssues() {
    this.setState({ loading: true });
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/blood-issues`, { credentials: "include" });
      const data = await res.json();
      this.setState({ issues: data.data || [], loading: false });
    } catch {
      this.setState({ loading: false, error: "Failed to load issued bags." });
    }
  }

  bgColor(group) {
    const map = {
      "A+": "#e74c3c", "A-": "#c0392b",
      "B+": "#2980b9", "B-": "#1a5276",
      "AB+": "#8e44ad", "AB-": "#6c3483",
      "O+": "#27ae60", "O-": "#1e8449",
    };
    return map[group] || "#555";
  }

  getFiltered() {
    const { issues, searchTerm, filterBloodGroup } = this.state;
    return issues.filter((i) => {
      const matchSearch = !searchTerm ||
        String(i.patient_id || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        i.donor_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(i.donor_code || "").toLowerCase().includes(searchTerm.toLowerCase());
      const matchGroup = !filterBloodGroup || i.blood_group === filterBloodGroup;
      return matchSearch && matchGroup;
    });
  }

  render() {
    const { loading, error, searchTerm, filterBloodGroup } = this.state;
    const filtered = this.getFiltered();
    const bloodGroups = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];

    return (
      <div style={{ background: "#f4f6fb", minHeight: "100vh" }} className="pt-5 mt-4">
        <div className="container py-4" style={{ maxWidth: 1100 }}>

          <div className="mb-4">
            <h4 className="fw-bold mb-1" style={{ color: "#c9140e" }}>
              <i className="bi bi-clipboard2-pulse-fill me-2" />
              Issued Blood Bags
            </h4>
            <p className="text-muted small mb-0">
              Record of blood bags issued to patients.
            </p>
          </div>

          {error && (
            <div className="alert alert-danger py-2 small mb-3">{error}</div>
          )}

          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                <h6 className="fw-bold mb-0">Issue Records</h6>
                <div className="d-flex gap-2 flex-wrap">
                  <div className="input-group" style={{ width: 220 }}>
                    <span className="input-group-text bg-white border-end-0" style={{ fontSize: 13 }}>
                      <i className="bi bi-search text-muted" />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search patient or donor..."
                      style={{ fontSize: 13 }}
                      value={searchTerm}
                      onChange={(e) => this.setState({ searchTerm: e.target.value })}
                    />
                  </div>
                  <select
                    className="form-select"
                    style={{ width: 110, fontSize: 13 }}
                    value={filterBloodGroup}
                    onChange={(e) => this.setState({ filterBloodGroup: e.target.value })}
                  >
                    <option value="">All Groups</option>
                    {bloodGroups.map((g) => <option key={g} value={g}>{g}</option>)}
                  </select>
                </div>
              </div>

              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-danger" />
                  <p className="text-muted small mt-2">Loading issued bags...</p>
                </div>
              ) : filtered.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <div style={{ fontSize: 48 }}>🏥</div>
                  <p className="mt-2 mb-0 fw-semibold">No issued bags found.</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th style={{ fontSize: 13 }}>#</th>
                        <th style={{ fontSize: 13 }}>Patient ID</th>
                        <th style={{ fontSize: 13 }}>Donor</th>
                        <th style={{ fontSize: 13 }}>Blood Group</th>
                        <th style={{ fontSize: 13 }}>Bag Serial</th>
                        <th style={{ fontSize: 13 }}>Donation Date</th>
                        <th style={{ fontSize: 13 }}>Issue Date</th>
                        <th style={{ fontSize: 13 }}>Issued At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filtered.map((i, idx) => (
                        <tr key={i.id}>
                          <td className="text-muted small">{idx + 1}</td>
                          <td className="small">{i.patient_id || "—"}</td>
                          <td>
                            <div className="fw-semibold small">{i.donor_name || "—"}</div>
                            <div className="text-muted" style={{ fontSize: 11 }}>{i.donor_code}</div>
                          </td>
                          <td>
                            <span style={{
                              background: this.bgColor(i.blood_group),
                              color: "#fff", borderRadius: 6,
                              padding: "3px 10px", fontWeight: 700, fontSize: 12,
                            }}>
                              {i.blood_group}
                            </span>
                          </td>
                          <td className="small text-muted">{i.bag_serial || "—"}</td>
                          <td className="small">{i.donation_date}</td>
                          <td className="small">{i.issue_date}</td>
                          <td className="small text-muted">
                            {i.created_at
                              ? new Date(i.created_at).toLocaleString("en-PK", { dateStyle: "short", timeStyle: "short" })
                              : "—"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {filtered.length > 0 && (
                <div className="mt-2 text-muted small text-end">
                  Showing {filtered.length} of {this.state.issues.length} records
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IssuedBloodBags;